import React, { PropTypes, PureComponent } from 'react';
import update from 'immutability-helper';

import apiService from '../../state/services/api';
import { eventFullPropTypeShape } from '../../proptypes';
import { isoStringToUTCDate } from '../../utils/dates';

import EventReviewForm from '../../components/EventReviewForm';

/**
 * Event review form container component.
 * Wraps form in state to handle API request and response.
 */
class EventReviewFormContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      textareaLimit: 200,
      values: {
        repeat: 1,
        // If there is only one race, default to ID for hidden field in form
        ...(props.races && props.races.races.length === 1) && {
          raceId: props.races.races[0].id,
        },
      },
      yearTo:
      // If the event year is in the future, assume current year took place
      isoStringToUTCDate(props.startDate).getFullYear() > new Date().getFullYear() ||
      // Or if the event is already in the past, assume the race also happened this year
      isoStringToUTCDate(props.startDate).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)
         ? new Date().getFullYear() : new Date().getFullYear() - 1,
    };
  }

  handleChange = (event) => {
    const { name } = event.target;
    let { value } = event.target;

    switch (name) {
      case 'repeatReview':
      case 'review':
      case 'organiserFeedback':
      case 'topTips':
        // Enfore a word count on textarea values
        value = value.split(' ').slice(0, this.state.textareaLimit).join(' ');
        break;
      case 'atmosphere':
      case 'course':
      case 'organisation':
      case 'repeat':
      case 'year':
        // Convert strings to numbers
        value = parseInt(value, 10);
        break;
      default:
        break;
    }

    this.setState(state =>
      update(state, {
        values: {
          [name]: { $set: value },
        },
      }), () => {
      const {
        values,
        values: { raceId, year, course, organisation, atmosphere, review },
      } = this.state;
      // Calculate aggregate rating from selected scores
      const scores = [course, organisation, atmosphere].filter(score => score);
      const overall = scores.reduce((sum, num) => num + sum, 0) / scores.length;
      this.setState({
        values: update(values, {
          overall: { $set: overall },
        }),
        valid: !!raceId && !!year && !!course && !!organisation && !!atmosphere && !!review,
      });
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.submitForm();
  };

  submitForm = () => {
    apiService.createReview({
      eventId: this.props.id,
      questions: this.cleanValues(this.state.values),
    })
      .then((response) => {
        const { values: { raceId } } = this.state;
        this.props.onSuccess({ ...response, raceId, eventId: this.props.id });
      })
      .then(() => {
        // Scroll to top as not changing page on success.
        document.body.scrollTop = 0;
      })
      .catch(({ message: error }) => {
        this.setState({
          error,
        });
      });
  };

  cleanValues = values => ({
    ...values,
    ...(values.repeat === 1) && {
      repeatReview: undefined,
    },
  });

  render() {
    return (
      <EventReviewForm
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        {...this.props}
        {...this.state}
      />
    );
  }
}

EventReviewFormContainer.propTypes = {
  /**
   * Numeric ID of the event.
   */
  id: eventFullPropTypeShape.id, // eslint-disable-line react/require-default-props
  /**
   * Function called on form success.
   */
  onSuccess: PropTypes.func,
  /**
   * Array of race objects.
   */
  races: eventFullPropTypeShape.races,
  /**
   * ISO string of event start date.
   */
  startDate: eventFullPropTypeShape.startDate, // eslint-disable-line react/require-default-props
};

EventReviewFormContainer.defaultProps = {
  onSuccess: () => {},
  races: undefined,
};

export default EventReviewFormContainer;



// WEBPACK FOOTER //
// ./app/src/containers/EventReviewForm/index.jsx